<div class="steps">
  <div *ngFor="let step of steps; let i = index;" class="step" [ngClass]="allActive ? 'active' : currentStep === i ? 'active' : 'minimized'" (click)="toggleStep(i)">
    <i class={{iconsClassName[i]}}></i>
    <section class="step-header">
      <h2>{{step | translate}}</h2>
    </section>
    <section class="step-content"></section>
  </div>
  <ng-content></ng-content>
</div>